import { injectStyle } from '../css.js';

export const css = `
#lightbox-overlay {
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  z-index: 1000;
  align-items: center;
  justify-content: center;
}
#lightbox-overlay.open {
  display: flex;
}
#lightbox-overlay img {
  max-width: 90vw;
  max-height: 90vh;
}
`;
injectStyle('lightbox-css', css);

const OVERLAY_ID = 'lightbox-overlay';

// One global overlay, inserted once at startup.
export function lightboxHtml() {
  return `<div id="${OVERLAY_ID}"><img alt=""></div>`;
}

// Re-binds click listeners to any .zoomimg img after every route render,
// since the DOM under #app is replaced each time.
export function initLightbox() {
  const overlay = document.getElementById(OVERLAY_ID);
  if (!overlay) return;
  const overlayImg = overlay.querySelector('img');

  document.querySelectorAll('.zoomimg img').forEach((img) => {
    img.addEventListener('click', () => {
      overlayImg.src = img.currentSrc || img.src;
      overlayImg.alt = img.alt || '';
      overlay.classList.add('open');
    });
  });

  if (!overlay.dataset.bound) {
    overlay.dataset.bound = 'true';
    overlay.addEventListener('click', () => overlay.classList.remove('open'));
  }
}
